function initFacetAccordion() {
  const items = document.querySelectorAll('.facetwp-type-checkboxes');

  items.forEach((item) => {
    if (window.innerWidth > 1024) {
      item.style.maxHeight = '';
      item.style.overflow = '';
      item.style.transition = '';
      item.classList.remove('is-open');

      const oldButton = item.previousElementSibling;

      if (oldButton?.classList.contains('facet-toggle-btn')) {
        oldButton.remove();
      }

      return;
    }

    const hasItems = item.querySelectorAll('.facetwp-checkbox').length > 0;

    if (!hasItems) {
      return;
    }

    if (item.previousElementSibling?.classList.contains('facet-toggle-btn')) {
      return;
    }

    item.style.overflow = 'hidden';
    item.style.maxHeight = '0px';
    item.style.transition = 'max-height 0.3s ease';

    const button = document.createElement('button');

    button.type = 'button';
    button.classList.add('facet-toggle-btn');
    button.textContent = '';

    button.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');

      if (isOpen) {
        item.style.maxHeight = '0px';
        item.classList.remove('is-open');
        button.classList.remove('btn-open');
      } else {
        item.style.maxHeight = item.scrollHeight + 'px';
        item.classList.add('is-open');
        button.classList.add('btn-open');
        button.textContent = '';
      }
    });

    item.parentNode.insertBefore(button, item);
  });
}
document.addEventListener('facetwp-loaded', function () {
  const facets = document.querySelectorAll('.facetwp-type-checkboxes');

  facets.forEach((facet) => {
    const items = facet.querySelectorAll('.facetwp-checkbox');

    if (items.length === 0) {
      return;
    }

    if (facet.dataset.titleAdded === '1') return;
    facet.dataset.titleAdded = '1';

    let name = facet.getAttribute('data-name');
    if (!name) return;

    name = name
      .replace(/[-_]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, (l) => l.toUpperCase());

    const title = document.createElement('h4');
    title.className = 'facet-title';
    title.textContent = name;

    facet.parentNode.insertBefore(title, facet);
  });
});

window.addEventListener('resize', initFacetAccordion);

document.addEventListener('facetwp-loaded', function () {
  initFacetAccordion();
});

window.addEventListener('resize', function () {
  initFacetAccordion();
});

function initFilterGroupsAccordion() {
  const groups = document.querySelectorAll('.filter-group');

  groups.forEach((group) => {
    const title = group.querySelector('h4');

    if (!title) return;

    const labels = [...group.querySelectorAll('.checkbox-label')].filter(
      (label) => {
        return window.getComputedStyle(label).display !== 'none';
      }
    );

    if (labels.length === 0) {
      return;
    }

    if (window.innerWidth > 1024) {
      group.style.maxHeight = '';
      group.style.overflow = '';
      group.style.transition = '';
      group.classList.remove('is-open');

      const oldButton = title.nextElementSibling;

      if (oldButton?.classList.contains('filter-toggle-btn')) {
        oldButton.remove();
      }

      labels.forEach((label) => {
        label.style.display = '';
      });

      return;
    }

    if (group.dataset.accordionInit === '1') {
      return;
    }

    group.dataset.accordionInit = '1';

    const content = document.createElement('div');
    content.classList.add('filter-group-content');

    labels.forEach((label) => {
      content.appendChild(label);
    });

    group.appendChild(content);

    content.style.overflow = 'hidden';
    content.style.maxHeight = '0px';
    content.style.transition = 'max-height 0.3s ease';

    const button = document.createElement('button');

    button.type = 'button';
    button.classList.add('filter-toggle-btn');
    button.textContent = title.textContent;

    title.style.display = 'none';

    button.addEventListener('click', function () {
      const isOpen = content.classList.contains('is-open');

      if (isOpen) {
        content.style.maxHeight = '0px';
        content.classList.remove('is-open');
        this.classList.remove('is-open');
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.classList.add('is-open');
        this.classList.add('is-open');
      }
    });

    group.insertBefore(button, content);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initFilterGroupsAccordion();
});

window.addEventListener('resize', function () {
  initFilterGroupsAccordion();
});
